// extracted by mini-css-extract-plugin
export default {"loadingScreen":"loadingScreen_loadingScreen__1ZYQH","loadingScreenIcon":"loadingScreen_loadingScreenIcon__Yz26Z"};